import App from "./components/App";
import './styles/cubesave.scss';
import StoreProvider from '@green24/npm-preact-utils/src/components/store/StoreProvider';
import store from "./store/store";
import ConfigurationLoader from "./components/other/ConfigurationLoader";
import LocalizationProvider from "./components/shared/Localization/LocalizationProvider";

export default () => (
	<StoreProvider store={store}>
		<LocalizationProvider>
			<ConfigurationLoader>
				<App/>
			</ConfigurationLoader>
		</LocalizationProvider>
	</StoreProvider>
);
